import React from 'react';
import { ActivityIcon, LayersIcon, TimerIcon, DumbbellIcon } from 'lucide-react';
const metrics = [{
  icon: ActivityIcon,
  value: '40+',
  label: 'Injuries & conditions covered'
}, {
  icon: LayersIcon,
  value: '6 + 5',
  label: 'Volumes and field tools'
}, {
  icon: TimerIcon,
  value: '90 sec',
  label: 'From "I have a…" to a confident plan'
}, {
  icon: DumbbellIcon,
  value: 'Mat + Reformer',
  label: 'Every single protocol, both modalities'
}];
export function ProofBar() {
  return <section aria-label="Screen & Adapt in numbers" className="w-full bg-forest text-white" data-id="element-239" data-mp="3j7g0s183o19">
      <ul className="mx-auto max-w-content divide-y divide-white/10 px-5 py-8 sm:px-8 sm:py-12 lg:grid lg:grid-cols-4 lg:gap-6 lg:divide-y-0 lg:py-16" data-id="element-240" data-mp="3krubf3739wvn">
        {metrics.map(({
        icon: Icon,
        value,
        label
      }) => <li key={label} className="flex items-center gap-4 py-4 lg:flex-col lg:gap-2 lg:py-0 lg:text-center" data-id="element-241" data-mp="1izpqibo0bzuf">
            <Icon className="h-6 w-6 shrink-0 text-sage-soft lg:h-7 lg:w-7" strokeWidth={1.5} aria-hidden="true" data-id="element-242" data-mp="1nyj21yjqhgry" />
            <div className="lg:contents" data-id="element-243" data-mp="2neu660zvx584">
              <p className="font-serif text-2xl font-semibold leading-tight text-white sm:text-3xl" data-id="element-244" data-mp="2ndrbrj3cskng">
                {value}
              </p>
              <p className="mt-0.5 font-sans text-[14px] leading-snug text-white/60 lg:mx-auto lg:mt-1 lg:max-w-[15rem] lg:text-[13px]" data-id="element-245" data-mp="2x5ezb8wshhjn">
                {label}
              </p>
            </div>
          </li>)}
      </ul>
    </section>;
}